// extracted by mini-css-extract-plugin
export default {"table-of-contents":"style_table-of-contents__avhWB"};